<template>
    <Modal class="popup_content" v-model="payrecordshows" width="400" @on-cancel="payrecordCancel">
        <div slot="header" class="popup_header_content">
            <span>{{payrecordtype == 0 ? '支付记录' : '收支记录'}}</span>
        </div>
        <div class="popup_head_body">
            <div class="payrecord_content" v-if="payrecordinfo != undefined">
                <span>{{payrecordtype == 0 ? '￥' : (payrecordinfo.typesign == 1 ? '+' : '-')}}{{payrecordinfo.cost}}</span>
                <div class="payrecord_list_content">
                    <Row v-if="payrecordtype == 1">
                        <Col span="7"><span>收支类型</span></Col>
                        <Col span="17"><p>{{payrecordinfo.typename}}</p></Col>
                    </Row>
                    <Row v-if="payrecordtype == 0">
                        <Col span="7"><span>付款状态</span></Col>
                        <Col span="17"><p>{{payrecordinfo.statusname}}</p></Col>
                    </Row>
                    <Row v-if="payrecordtype == 0 && payrecordinfo.status == 2 || payrecordtype == 1 && payrecordinfo.type == 2">
                        <Col span="7"><span>{{payrecordtype == 0 ? '取消原因' : '退款原因'}}</span></Col>
                        <Col span="17"><p>{{payrecordinfo.reason}}</p></Col>
                    </Row>
                    <Row>
                        <Col span="7"><span>支付方式</span></Col>
                        <Col span="17"><p>{{payrecordinfo.paytype}}</p></Col>
                    </Row>
                    <Row v-if="payrecordtype == 0 || payrecordtype == 1 && payrecordinfo.type != 4">
                        <Col span="7"><span>关联单号</span></Col>
                        <Col span="17"><p>{{payrecordinfo.dno}}</p></Col>
                    </Row>
                    <Row v-if="payrecordtype == 0 || payrecordtype == 1 && payrecordinfo.type != 2">
                        <Col span="7"><span>提交时间</span></Col>
                        <Col span="17"><p>{{payrecordinfo.addtime}}</p></Col>
                    </Row>
                    <Row v-if="payrecordtype == 0 || payrecordtype == 1 && payrecordinfo.type != 1">
                        <Col span="7"><span>{{payrecordinfo.type != 2 ? '审核确认时间' : '退款时间'}}</span></Col>
                        <Col span="17"><p>{{payrecordinfo.passtime}}</p></Col>
                    </Row>
                    <Row v-if="payrecordtype == 0 || payrecordtype == 1 && payrecordinfo.type != 1 && payrecordinfo.type != 2">
                        <Col span="7"><span>转账日期</span></Col>
                        <Col span="17"><p>{{payrecordinfo.paytime}}</p></Col>
                    </Row>
                    <Row v-if="payrecordtype == 0 && payrecordinfo.accountbank != '' && payrecordinfo.accountbank != null || payrecordinfo.accountbank != '' && payrecordinfo.accountbank != null && payrecordtype == 1 && payrecordinfo.type != 1 && payrecordinfo.type != 2">
                        <Col span="7"><span>收款账户</span></Col>
                        <Col span="17">
                            <p>{{payrecordinfo.accountbank}}</p>
                            <p>{{payrecordinfo.accountname}}</p>
                            <p>{{payrecordinfo.accountnum}}</p>
                        </Col>
                    </Row>
                    <Row v-if="payrecordtype == 0 || payrecordtype == 1 && payrecordinfo.type != 1 && payrecordinfo.type != 2">
                        <Col span="7"><span>备注</span></Col>
                        <Col span="17"><p>{{payrecordinfo.content}}</p></Col>
                    </Row>
                    <Row v-if="payrecordtype == 0 || payrecordtype == 1 && payrecordinfo.type != 1 && payrecordinfo.type != 2">
                        <Col span="7"><span>支付凭证</span></Col>
                        <Col span="24">
                            <div class="payrecord_list_img">
                                <img :src="imgurl" v-if="imgshow" />
                                <ul>
                                    <li
                                        v-for="(item, index) in payrecordinfo.filetip"
                                        :key="index"
                                        @mouseenter="payrecordEnter(item)"
                                        @mouseleave="payrecordLeave"
                                        :style="{backgroundImage: 'url(' + item + ')'}"
                                    >
                                    </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
        <div slot="footer"></div>
    </Modal>
</template>

<script>
    export default {
        props: ['payrecordShow', 'payrecordtype', 'payrecordinfo'],
        data() {
            return {
                payrecordshows: false, // 弹窗是否显示
                imgshow: false, // 图片是否显示
                imgurl: '', // 放大的图片
                payrecordtypes: 0, // 0 支付记录 1 预存款收支明细
            }
        },
        methods: {
            payrecordEnter (url) { // 鼠标经过图片
                this.imgshow = true
                this.imgurl = url
            },
            payrecordLeave () { // 鼠标离开图片
                this.imgshow = false
            },
            payrecordCancel () { // 关闭按钮
                this.payrecordshows = false
                this.$emit('payrecordCancel')
            }
        },
        watch: {
            payrecordShow () {
                this.payrecordshows = this.payrecordShow
                console.log(this.payrecordinfo)
            }
        }
    }
</script>

<style scoped>

.payrecord_content > span {
    text-align: center;
    font-size: 18px;
    color: #FF8000;
    display: block;
}

.payrecord_list_content > .ivu-row {
    padding: 10px 0;
    border-bottom: 1px solid #f0f0f0;
}

.payrecord_list_content > .ivu-row:last-child {
    border-bottom: none;
}

.payrecord_list_content span {
    font-size: 14px;
    color: #333;
}

.payrecord_list_content p {
    font-size: 14px;
    color: #666;
    word-break: break-all;
}

.payrecord_list_img {
    position: relative;
}

.payrecord_list_img > img {
    max-width: 100%;
    max-height: 440px;
    position: absolute;
    left: 0;
    bottom: 100%;
    z-index: 1;
}

.payrecord_list_img > ul {
    font-size: 0;
}

.payrecord_list_img > ul > li {
    width: 60px;
    height: 60px;
    margin: 8px 8px 0 0;
    display: inline-block;
    background-color: #333;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    cursor: pointer;
}

</style>


// WEBPACK FOOTER //
// src/components/component/popup/payrecord.vue